import { Box, Drawer, DrawerOverlay, DrawerContent } from "@chakra-ui/react";
import { BaseButton, BaseStack, baseColors } from "goi_common/src/design-system";

const destinations = [
  ["다른 장례식장과 비교하기", "/funeral-facilities/parlor/", "exit_compare"],
  ["무빈소장 가능 여부 알아보기", "/match/request/?template=mubinso", "exit_mubinso"],
  ["상조 상품 확인하기", "/service/", "exit_service"],
] as const;

export default function ParlorExitDrawer({
  isOpen,
  onClose,
  onNavigate,
  onQuit,
}: {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (url: string, event: "exit_compare" | "exit_mubinso" | "exit_service") => void;
  onQuit: () => void;
}) {
  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
      <DrawerOverlay bg="rgba(23,24,25,0.5)" />
      <DrawerContent
        aria-labelledby="parlor-exit-title"
        width="100%"
        css={{
          "&&": {
            width: "min(100%, 480px) !important",
            maxWidth: "480px !important",
            left: 0,
            right: 0,
            marginInline: "auto",
          },
        }}
        maxW="480px"
        mx="auto"
        borderTopRadius="24px"
        maxH="90vh"
        overflowY="auto"
      >
        <BaseStack spacing={24} p="24px 24px 16px" color={baseColors.label_normal}>
          <BaseStack spacing={12}>
            <BaseStack direction="horizontal" spacing={8} alignItems="center">
              <Box
                as="h2"
                id="parlor-exit-title"
                flex={1}
                fontSize="21px"
                fontWeight={700}
                lineHeight="30px"
              >
                다른 정보가 필요하신가요?
              </Box>
              <Box
                w="40px"
                flexShrink={0}
                sx={{ button: { height: "40px", padding: 0, background: "transparent" } }}
              >
                <BaseButton type="assistive_1" size="small" onClick={onClose}>
                  <img src="/parlor-exit/close.svg" width={16} height={16} alt="닫기" />
                </BaseButton>
              </Box>
            </BaseStack>
            <Box fontSize="16px" lineHeight="24px" color={baseColors.label_alternative_1}>
              궁금한 내용을 천천히 살펴보세요.
              <br />
              <Box as="span" color={baseColors.orange_500} fontWeight={700}>
                18만명의 장례를 도와드린 고이
              </Box>
              가 고객님의 궁금증을 해소해드릴게요.
            </Box>
          </BaseStack>
          <BaseStack
            spacing={12}
            width="100%"
            css={{
              button: {
                height: "64px",
                whiteSpace: "normal",
                borderRadius: "12px",
                border: "1px solid #DEDEDE",
                background: "#FAFAFA",
                padding: "0 16px",
              },
            }}
          >
            {destinations.map(([label, url, event]) => (
              <BaseButton
                key={url}
                type="assistive_2"
                size="large"
                onClick={() => onNavigate(url, event)}
              >
                <BaseStack direction="horizontal" alignItems="center" width="100%" spacing={12}>
                  <Box flex={1} minW={0} textAlign="left" fontSize="16px" fontWeight={600}>
                    {label}
                  </Box>
                  <Box flexShrink={0}>
                    <img src="/parlor-exit/chevron.svg" width={16} height={16} alt="" />
                  </Box>
                </BaseStack>
              </BaseButton>
            ))}
          </BaseStack>
          <Box
            width="100%"
            css={{
              button: {
                height: "44px",
                background: "transparent",
                color: "#686868",
                textDecoration: "underline",
                fontSize: "14px",
                fontWeight: 600,
              },
            }}
          >
            <BaseButton type="assistive_1" size="medium" onClick={onQuit}>
              지금은 나갈게요
            </BaseButton>
          </Box>
        </BaseStack>
      </DrawerContent>
    </Drawer>
  );
}
